import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../../../environments/environment';
import { ServiceCRUD } from './../../../../shared/crud/ServiceCRUD';

@Injectable({
  providedIn: 'root'
})
export class CommercialVarejoService extends ServiceCRUD {
  private baseUrlService: string;
  private url: string;
  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.url
    ;
  }

  public setURL(url: string) {
    var temp = `${this.baseUrlService}` + url;
    this.url = temp;
  }
  
}
